// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const SEARCH_CUSTOMERS = 'customer/searchCustomers';
export const {
  pending: SEARCH_CUSTOMERS_PENDING,
  fulfilled: SEARCH_CUSTOMERS_FULFILLED,
  rejected: SEARCH_CUSTOMERS_REJECTED,
} = createAsyncActionTypes(SEARCH_CUSTOMERS);

export const FETCH_CUSTOMER = 'customer/fetchCustomer';
export const {
  pending: FETCH_CUSTOMER_PENDING,
  fulfilled: FETCH_CUSTOMER_FULFILLED,
  rejected: FETCH_CUSTOMER_REJECTED,
} = createAsyncActionTypes(FETCH_CUSTOMER);

export const FETCH_REGIONS = 'customer/fetchRegions';
export const {
  pending: FETCH_REGIONS_PENDING,
  fulfilled: FETCH_REGIONS_FULFILLED,
  rejected: FETCH_REGIONS_REJECTED,
} = createAsyncActionTypes(FETCH_REGIONS);

export const FETCH_PARTNERS = 'customer/fetchPartners';
export const {
  pending: FETCH_PARTNERS_PENDING,
  fulfilled: FETCH_PARTNERS_FULFILLED,
  rejected: FETCH_PARTNERS_REJECTED,
} = createAsyncActionTypes(FETCH_PARTNERS);

export const UPDATE_CUSTOMER = 'customer/updateCustomer';
export const {
  pending: UPDATE_CUSTOMER_PENDING,
  fulfilled: UPDATE_CUSTOMER_FULFILLED,
  rejected: UPDATE_CUSTOMER_REJECTED,
} = createAsyncActionTypes(UPDATE_CUSTOMER);

export const SEND_VERIFICATION_EMAIL = 'customer/sendVerificationEmail';
export const {
  pending: SEND_VERIFICATION_EMAIL_PENDING,
  fulfilled: SEND_VERIFICATION_EMAIL_FULFILLED,
  rejected: SEND_VERIFICATION_EMAIL_REJECTED,
} = createAsyncActionTypes(SEND_VERIFICATION_EMAIL);

export const RESET_PASSWORD = 'customer/resetPassword';
export const {
  pending: RESET_PASSWORD_PENDING,
  fulfilled: RESET_PASSWORD_FULFILLED,
  rejected: RESET_PASSWORD_REJECTED,
} = createAsyncActionTypes(RESET_PASSWORD);

export const SKIP_MFA = 'customer/skipMfa';
export const {
  pending: SKIP_MFA_PENDING,
  fulfilled: SKIP_MFA_FULFILLED,
  rejected: SKIP_MFA_REJECTED,
} = createAsyncActionTypes(SKIP_MFA);

export const LOGOUT_ALL_DEVICES = 'customer/logoutAllDevices';
export const {
  pending: LOGOUT_ALL_DEVICES_PENDING,
  fulfilled: LOGOUT_ALL_DEVICES_FULFILLED,
  rejected: LOGOUT_ALL_DEVICES_REJECTED,
} = createAsyncActionTypes(LOGOUT_ALL_DEVICES);

export const CLOSE_CUSTOMER = 'customer/closeCustomer';
export const {
  pending: CLOSE_CUSTOMER_PENDING,
  fulfilled: CLOSE_CUSTOMER_FULFILLED,
  rejected: CLOSE_CUSTOMER_REJECTED,
} = createAsyncActionTypes(CLOSE_CUSTOMER);

export const REOPEN_CUSTOMER = 'customer/reopenCustomer';
export const {
  pending: REOPEN_CUSTOMER_PENDING,
  fulfilled: REOPEN_CUSTOMER_FULFILLED,
  rejected: REOPEN_CUSTOMER_REJECTED,
} = createAsyncActionTypes(REOPEN_CUSTOMER);

export const REMOVE_BLOCKS = 'customer/removeBlocks';
export const {
  pending: REMOVE_BLOCKS_PENDING,
  fulfilled: REMOVE_BLOCKS_FULFILLED,
  rejected: REMOVE_BLOCKS_REJECTED,
} = createAsyncActionTypes(REMOVE_BLOCKS);

export const CREATE_USER = 'customer/createUser';
export const {
  pending: CREATE_USER_PENDING,
  fulfilled: CREATE_USER_FULFILLED,
  rejected: CREATE_USER_REJECTED,
} = createAsyncActionTypes(CREATE_USER);

export const SET_SEARCH_PARAMS = 'customer/setSearchParams';
